function changePage (stockState, setStockState, action) {
    if (action === "previous" && stockState.page > 1) {
        setStockState({...stockState, page: stockState.page -1})
    }
    if (action === "next" && stockState.page > 0) {
        setStockState({...stockState, page: stockState.page +1})
    }
}

export default changePage;